import { loadImage } from '@/utils/load-image'

import type { PrinterConfig, PrinterDriver } from '../types'
import { EscPosEncoder } from './esc-pos-encoder'

export default class UsbPrinter implements PrinterDriver {
  private ipcRenderer: any
  private config: PrinterConfig

  constructor(config: PrinterConfig) {
    try {
      const { ipcRenderer } = window.require('electron')
      this.ipcRenderer = ipcRenderer
      this.config = config
    } catch {
      throw new Error('No USB capability')
    }
  }

  async printImage(imageData: string) {
    const encoder = new EscPosEncoder()
    const img = await loadImage(imageData)
    const ipcRenderer = this.ipcRenderer
    const width = 504
    const ratio = width / img.width
    const height = Math.round((img.height * ratio) / 8) * 8
    const result = encoder
      .align('center')
      .image(img, width, height)
      .newline(5)
      .cut('partial')
      .encode()

    return ipcRenderer.invoke('print-usb', this.config.name, result)
  }

  async openCashDrawer() {
    const encoder = new EscPosEncoder()
    const result = encoder.openCashDrawer().encode()

    this.ipcRenderer.invoke('print-usb', this.config.name, result)
  }

  static discoverPrinters(): Promise<
    {
      name: string
      portName?: string
      attributes: string[]
      options?: { 'device-uri': string }
    }[]
  > {
    const { ipcRenderer } = window.require('electron')
    return ipcRenderer.invoke('get-connected-usb-printers')
  }
}
